// ── Tenant-Resolving Portal Route ──
// Resolves tenant from URL slug and wraps portal in PortalProvider.

import { useParams } from "react-router-dom";
import { useMemo } from "react";
import { PortalProvider } from "@/data/portal/context";
import WhiteLabelPortal from "@/pages/WhiteLabelPortal";

export function TenantPortalRoute() {
  const { tenantSlug } = useParams<{ tenantSlug: string }>();

  const tenantId = useMemo(() => {
    if (!tenantSlug) return "tenant-001";
    return tenantSlug;
  }, [tenantSlug]);

  return (
    <PortalProvider tenantId={tenantId}>
      <WhiteLabelPortal />
    </PortalProvider>
  );
}
